export const visitFreqConfig = {
  id: "visitFrequency",
  componentId: "visitFrequency",
  type: "listCard",
  access: "write",
  editable: true,
  manualAdd: true,
  data: {
    listHeaders: [
      "discipline",
      "visits",
      "timeInterval",
      "prnVisits",
      "reason",
      "startDate",
      "endDate",
    ],
  },
  inputs: {
    discipline: {
      type: "select",
      componentId: "discipline",
      options: [
        { value: "SD002.1", display: "caseManager" },
        { value: "SD002.2", display: "teamLead" },
        { value: "SD002.3", display: "registeredNurseRN" },
        { value: "SD002.4", display: "nursePracticioner" },
        { value: "SD002.5", display: "hospiceAide" },
        { value: "SD002.6", display: "homemaker" },
        { value: "SD002.7", display: "socialWorker" },
        { value: "SD002.8", display: "spiritualAdvisor" },
        { value: "SD002.9", display: "bereavement" },
        { value: "SD002.10", display: "medicalDirector" },
        { value: "SD002.12", display: "volunteerCoordinator" },
        { value: "SD002.11", display: "lpnLvnNurse" },
        { value: "SD002.13", display: "volunteer" },
      ],
      supportOther: true,
      rules: {
        required: true,
      },
    },
    visits: {
      type: "select",
      componentId: "visits",
      options: [
        { value: "CL011.1", display: "1 time" },
        { value: "CL011.2", display: "2 times" },
        { value: "CL011.3", display: "3 times" },
        { value: "CL011.4", display: "4 times" },
        { value: "CL011.5", display: "5 times" },
        { value: "CL011.6", display: "-" },
      ],
      rules: {
        required: true,
      },
    },
    timeInterval: {
      type: "select",
      componentId: "timeInterval",
      options: [
        { value: "CL012.1", display: "day" },
        { value: "CL012.2", display: "week" },
        { value: "CL012.3", display: "2weeks" },
        { value: "CL012.4", display: "3weeks" },
        { value: "CL012.5", display: "month" },
        { value: "CL012.6", display: "-" },
      ],
      rules: {
        required: true,
      },
    },
    prnVisits: {
      type: "select",
      componentId: "discipline",
      options: [
        { value: "CL013.0", display: "-" },
        { value: "CL013.1", display: "1 PRN" },
        { value: "CL013.2", display: "2 PRN" },
        { value: "CL013.3", display: "3 PRN" },
        { value: "CL013.4", display: "4 PRN" },
        { value: "CL013.5", display: "5 PRN" },
      ],
    },
    reason: {
      type: "select",
      componentId: "discipline",
      multiple: true,
      options: [
        { value: "CL014.1", display: "perChangeInCondition" },
        { value: "CL014.2", display: "perFamilyPcgRequest" },
      ],
    },
    reasonOther: {
      type: "checkbox",
      label: "Other Reason",
      componentId: "reasonOther",
      options: ["other"],
    },
    reasonValue: {
      type: "text",
      label: false,
      componentId: "reason",
      rules: {
        required: true,
        maxLength: 100,
      },
    },
    startDate: {
      type: "date",
      componentId: "startDate",
      rules: {
        startDate: "lastdecadeFromToday",
        endDate: "decadeFromToday",
        required: true,
      },
    },
    endDate: {
      type: "date",
      componentId: "endDate",
      rules: {
        startDate: "today",
        required: true,
      },
    },
  },
  dependencies: [
    {
      id: "reasonOther",
      values: [],
      type: "disable",
      fields: ["reasonValue"],
    },
    {
      id: "reasonOther",
      values: [],
      type: "clear",
      fields: ["reasonValue"],
    },
    {
      id: "reasonOther",
      values: ["other"],
      type: "clear",
      fields: ["reason"],
    },
    {
      id: "reason",
      values: ["CL014.1", "CL014.2"],
      type: "clear",
      fields: ["reasonOther", "reasonValue"],
    },
    {
      id: "reason",
      values: ["CL014.1", "CL014.2"],
      type: "disable",
      fields: ["reasonValue"],
    },
    // {
    //     "id": "reason",
    //     "values": ['other'],
    //     "type": "showControl",
    //     "fields": [
    //         "reasonValue"
    //     ]
    // }
  ],
};



// WEBPACK FOOTER //
// ./src/configs/visit-freq-config.ts